module.exports = __webpack_public_path__ + "static/media/ScreenShot_Genejs_2020-06-27.8efcd3d7.png";